import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '&.delete-button--horizontal': {
    '.delete-button__btn-icon': {
      marginRight: theme.space[2],
    },
  },
  '&.delete-button--vertical': {
    '.delete-button__btn': {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },
  },
  '.delete-button': {
    '&__btn': {
      padding: 0,
    },
  },
});
